import React from 'react';
import { motion } from 'framer-motion';

const sectionFadeIn = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.7, ease: 'easeInOut' },
  viewport: { once: true, amount: 0.2 }
};

export default function SolutionSection() {
  return (
    <motion.section
      className="solution-section"
      initial="initial"
      whileInView="whileInView"
      transition={sectionFadeIn.transition}
      viewport={sectionFadeIn.viewport}
    >
      <div className="container">
        <motion.div className="section-content">
          <motion.h2 {...sectionFadeIn}>
            🎯 Guessing vs Proven System
          </motion.h2>
          <motion.p
            className="solution-intro"
            {...sectionFadeIn}
            transition={{ delay: 0.1, ...sectionFadeIn.transition }}
          >
            You're not behind because you lack skills. <strong>You're behind
            because you don't have a scalable system.</strong> Neenga effort
            podra, but income still inconsistent ah irundha, it's time to stop
            guessing and start following a proven framework.
          </motion.p>
          <div className="comparison-table">
            <motion.div
              className="old-way"
              {...sectionFadeIn}
              transition={{ delay: 0.2, ...sectionFadeIn.transition }}
            >
              <h3>❌ Without a System (Guessing)</h3>
              <ul>
                <li>Income is unpredictable month to month</li>
                <li>Always busy but results don't match effort</li>
                <li>Attracting free seekers instead of serious clients</li>
                <li>Undercharging due to weak positioning</li>
                <li>People don't understand what you do</li>
                <li>Starting from zero every month</li>
                <li>Activity doesn't equal growth</li>
              </ul>
            </motion.div>
            <motion.div
              className="new-way"
              {...sectionFadeIn}
              transition={{ delay: 0.4, ...sectionFadeIn.transition }}
            >
              <h3>✅ With a Proven System (Predictable)</h3>
              <ul>
                <li>Consistent income through scalable client acquisition</li>
                <li>Conversion-focused system, not more hustle</li>
                <li>Attract only serious, ready-to-pay clients</li>
                <li>Position confidently and charge premium prices</li>
                <li>Clear, magnetic positioning that converts</li>
                <li>Predictable pipeline of qualified leads</li>
                <li>Growth becomes a process, not luck</li>
              </ul>
            </motion.div>
          </div>
          <motion.p
            style={{
              textAlign: 'center',
              fontSize: '1.2rem',
              marginTop: '2rem',
              color: '#fbbf24',
              fontWeight: '600'
            }}
            {...sectionFadeIn}
            transition={{ delay: 0.6, ...sectionFadeIn.transition }}
          >
            Ungalukum adhe system irundha, consistent income is not luck — it's
            process. 🚀
          </motion.p>
        </motion.div>
      </div>
    </motion.section>
  );
}